import { auth } from "services/firebase";
import { platformFetch } from "services/platformFetch";
async function request(path, options = {}, user = auth?.currentUser) {
  if (!user) throw new Error("Entre na sua conta para continuar.");
  const response = await platformFetch(path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await user.getIdToken()}`,
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Não foi possível consultar as permissões.");
  return body;
}
export const getAccessSession = (user) => request("/api/session", {}, user);
export const getAccessUsers = () => request("/api/admin/users");
export const saveAccessUser = (value) =>
  request("/api/admin/users", { method: "PUT", body: JSON.stringify(value) });
